export default "__VITE_ASSET__1zGDCJ0f__"